import { render, staticRenderFns } from "./PayrollColumnHeading.vue?vue&type=template&id=80c3a70e&scoped=true&"
import script from "./PayrollColumnHeading.vue?vue&type=script&lang=js&"
export * from "./PayrollColumnHeading.vue?vue&type=script&lang=js&"
import style0 from "./PayrollColumnHeading.vue?vue&type=style&index=0&id=80c3a70e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c3a70e",
  null
  
)

export default component.exports